module.exports = __webpack_public_path__ + "media/correct3.aa8156fb.mp3";